module.exports = [
    {
        "id_primary": "180722503",
        "id_order": "13212333",
        "id_content": "display_branch_1",
        "delete_field": "0",
        "label": "Line 1:",
        "data": "",
        "align": null,
        "color": null,
        "data_limit_override": "0",
        "font": null,
        "font_size": null
    },

    {
    "id_primary": "180722504",
    "id_order": "13212333",
    "id_content": "display_branch_2",
    "delete_field": "0",
    "label": "Line 2:",
    "data": "212 E Ohio Suite 200",
    "align": null,
    "color": null,
    "data_limit_override": "0",
    "font": null,
    "font_size": null
}, {
    "id_primary": "180722505",
    "id_order": "13212333",
    "id_content": "display_branch_3",
    "delete_field": "0",
    "label": "Line 3:",
    "data": "Chicago, IL 60618",
    "align": null,
    "color": null,
    "data_limit_override": "0",
    "font": null,
    "font_size": null
}, {
    "id_primary": "180722506",
    "id_order": "13212333",
    "id_content": "display_branch_4",
    "delete_field": "0",
    "label": "Line 4:",
    "data": "",
    "align": null,
    "color": null,
    "data_limit_override": "0",
    "font": null,
    "font_size": null
}, {
    "id_primary": "180722507",
    "id_order": "13212333",
    "id_content": "display_branch_5",
    "delete_field": "0",
    "label": "Line 5:",
    "data": "",
    "align": null,
    "color": null,
    "data_limit_override": "0",
    "font": null,
    "font_size": null
}, {
    "id_primary": "180722508",
    "id_order": "13212333",
    "id_content": "display_branch_6",
    "delete_field": "0",
    "label": "Website\/Line 6:",
    "data": "",
    "align": null,
    "color": null,
    "data_limit_override": "0",
    "font": null,
    "font_size": null
}, {
    "id_primary": "180722509",
    "id_order": "13212333",
    "id_content": "property_address",
    "delete_field": "0",
    "label": "Property Address",
    "data": "",
    "align": "",
    "color": null,
    "data_limit_override": "0",
    "font": null,
    "font_size": null
}, {
    "id_primary": "180722510",
    "id_order": "13212333",
    "id_content": "property_price",
    "delete_field": "0",
    "label": "Price",
    "data": "",
    "align": "",
    "color": null,
    "data_limit_override": "0",
    "font": null,
    "font_size": null
}, {
    "id_primary": "180722511",
    "id_order": "13212333",
    "id_content": "field_2",
    "delete_field": "0",
    "label": "Postcard Comments",
    "data": "",
    "align": "",
    "color": null,
    "data_limit_override": "0",
    "font": null,
    "font_size": null
}, {
    "id_primary": "180722512",
    "id_order": "13212333",
    "id_content": "field_13",
    "delete_field": "0",
    "label": "Bathrooms",
    "data": "",
    "align": "",
    "color": null,
    "data_limit_override": "0",
    "font": null,
    "font_size": null
}, {
    "id_primary": "180722513",
    "id_order": "13212333",
    "id_content": "field_66",
    "delete_field": "0",
    "label": "Just Listed \/ Just Sold",
    "data": "",
    "align": "",
    "color": null,
    "data_limit_override": "0",
    "font": null,
    "font_size": null
}, {
    "id_primary": "180722514",
    "id_order": "13212333",
    "id_content": "field_15",
    "delete_field": "0",
    "label": "Bedrooms",
    "data": "",
    "align": "",
    "color": null,
    "data_limit_override": "0",
    "font": null,
    "font_size": null
}, {
    "id_primary": "180722515",
    "id_order": "13212333",
    "id_content": "field_67",
    "delete_field": "0",
    "label": "Broker Name",
    "data": "",
    "align": "",
    "color": null,
    "data_limit_override": "0",
    "font": null,
    "font_size": null
}, {
    "id_primary": "180722516",
    "id_order": "13212333",
    "id_content": "field_68",
    "delete_field": "0",
    "label": "Title",
    "data": "",
    "align": "",
    "color": null,
    "data_limit_override": "0",
    "font": null,
    "font_size": null
}, {
    "id_primary": "180722517",
    "id_order": "13212333",
    "id_content": "field_69",
    "delete_field": "0",
    "label": "Phone Label",
    "data": "[\u0022Office \u0022,\u0022Cell \u0022,\u0022Mobile \u0022,\u0022Direct\u0022]",
    "align": "",
    "color": null,
    "data_limit_override": "0",
    "font": null,
    "font_size": null
}, {
    "id_primary": "180722518",
    "id_order": "13212333",
    "id_content": "field_70",
    "delete_field": "0",
    "label": "Email Address",
    "data": "",
    "align": "",
    "color": null,
    "data_limit_override": "0",
    "font": null,
    "font_size": null
}, {
    "id_primary": "180722519",
    "id_order": "13212333",
    "id_content": "field_71",
    "delete_field": "0",
    "label": "Website",
    "data": "",
    "align": "",
    "color": null,
    "data_limit_override": "0",
    "font": null,
    "font_size": null
}, {
    "id_primary": "180722520",
    "id_order": "13212333",
    "id_content": "field_72",
    "delete_field": "0",
    "label": "Phone Number",
    "data": "",
    "align": "",
    "color": null,
    "data_limit_override": "0",
    "font": null,
    "font_size": null
}];